import { MIME_EXTENSION_MAP } from '@pct-ng/common/file';
import { ensureItemsArray } from '@pct-ts/common';
import { isNil } from '@pct-ts/typeguard';
import type { FileUploadConfig } from '../type/file-upload-config';

export function joinMimeTypeToExtension(mimeType: FileUploadConfig['accept']): string {
  if (isNil(mimeType)) {
    return '';
  }
  return ensureItemsArray(mimeType)
    .map(mime => {
      if (mime in MIME_EXTENSION_MAP) {
        return MIME_EXTENSION_MAP[mime].join(', ');
      }
      console.warn(`Unknown MIME type: ${mime}`);
      return '';
    })
    .join(', ');
}
